import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ArticleTemplate from 'Containers/Public/ArticleTemplate/ArticleTemplate';
import { findArticleCall } from 'Containers/Public/ArticleTemplate/ArticleTemplateAxiosFuncs';
import { slugify } from 'Utils/utilityFunctions';

// Landing spot for the /articles/:id to /articles/:id/:slug
const ArticleRedirect = ({ setCustomCrumb }) => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    findArticleCall(Number(id)).then((res) => {
      const notFound = res?.status !== 1 || res?.globalErrorMessageList?.length > 0 || !res?.data?.title;
      if (!cancelled && !notFound) {
        navigate(`/articles/${id}/${slugify((res.data.title).trim())}`, { replace: true });
      }
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [id, navigate]);

  return <ArticleTemplate setCustomCrumb={setCustomCrumb} />;
};

export default ArticleRedirect;
